import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';

import { Store } from '@ngrx/store';
import { AppState } from '@state/app.state';
import { signOutAction, setAuthModal } from '@state/auth/auth.actions';

@Component({
  selector: 'app-reauthenticate',
  templateUrl: './reauthenticate.component.html',
  styleUrls: ['./reauthenticate.component.scss'],
})
export class ReauthenticateComponent implements OnInit {
  protected errType?: 'embed' = undefined;

  constructor(
    private store: Store<AppState>,
    private route: ActivatedRoute,
    private router: Router
  ) {}

  ngOnInit(): void {
    this.store.dispatch(setAuthModal({ authModal: undefined }));
    this.store.dispatch(signOutAction({ skipRedirect: true }));

    this.route.queryParams.subscribe((params) => {
      const magicToken = params['token'];
      const strategy = params['strategy'];
      const originalUrl = params['originalUrl'] || '/';
      const errType = params['errType'] as 'embed' | undefined;

      this.errType = errType;

      this.router.navigate(['/auth/magic-token'], {
        queryParams: { token: magicToken, strategy, originalUrl, errType },
      });
    });
  }
}
